'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var HourPicker = /*#__PURE__*/function () {
  function HourPicker(prmObjHour) {
    _classCallCheck(this, HourPicker);
    this.parameters = prmObjHour;
    this.hourPicker = this.createHourSelector();
    if (this.parameters.onValueUpdate !== null) {
      this.onValueUpdateSelect();
    }
  }
  return _createClass(HourPicker, [{
    key: "createHourOption",
    value: function createHourOption(prmHour, prmMinute, prmSelect) {
      var option = document.createElement('option');
      var hourString = "".concat("0".concat(prmHour).slice(-2), ":").concat("0".concat(prmMinute).slice(-2));
      option.value = hourString;
      if (this.parameters.showInterval) {
        var startHour = new Date(1970, 0, 1, prmHour, prmMinute, 0);
        startHour.setMinutes(startHour.getMinutes() + this.parameters.minuteInterval);
        option.innerHTML = "".concat(hourString, " - ").concat("0".concat(startHour.getHours()).slice(-2), ":").concat("0".concat(startHour.getMinutes()).slice(-2));
      } else {
        option.innerHTML = hourString;
      }
      try {
        prmSelect.appendChild(option);
      } catch (error) {
        console.error("Can't append option element on ".concat(this.parameters.element, " ").concat(error));
      }
    }
  }, {
    key: "createHourSelector",
    value: function createHourSelector() {
      var select = document.querySelector(this.parameters.element);
      this.removeOldHourOptions();
      if (this.parameters.askForChoice) {
        var _this$parameters$tran;
        select.insertAdjacentHTML('afterbegin', "<option value=\"choice\" data-order=\"choice\" disabled>".concat(((_this$parameters$tran = this.parameters.translation) === null || _this$parameters$tran === void 0 ? void 0 : _this$parameters$tran.chooseHour) || '-- Choisissez une heure --', "</option>"));
      }
      var stepMillis = this.parameters.minuteInterval * 60 * 1000;
      if (this.parameters.hour.slots && Array.isArray(this.parameters.hour.slots)) {
        var _iterator = _createForOfIteratorHelper(this.parameters.hour.slots),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              startStr = _step$value[0],
              endStr = _step$value[1];
            var _startStr$split = startStr.split(':'),
              _startStr$split2 = _slicedToArray(_startStr$split, 3),
              sh = _startStr$split2[0],
              sm = _startStr$split2[1],
              _startStr$split2$ = _startStr$split2[2],
              ss = _startStr$split2$ === void 0 ? '00' : _startStr$split2$;
            var _endStr$split = endStr.split(':'),
              _endStr$split2 = _slicedToArray(_endStr$split, 3),
              eh = _endStr$split2[0],
              em = _endStr$split2[1],
              _endStr$split2$ = _endStr$split2[2],
              es = _endStr$split2$ === void 0 ? '00' : _endStr$split2$;
            var start = new Date(1970, 0, 1, Number(sh), Number(sm), Number(ss));
            var end = new Date(1970, 0, 1, Number(eh), Number(em), Number(es));
            var cursor = new Date(start.getTime());
            while (cursor.getTime() <= end.getTime()) {
              this.createHourOption(cursor.getHours(), cursor.getMinutes(), select);
              cursor.setTime(cursor.getTime() + stepMillis);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        var _this$parameters$hour = this.parameters.hour.start.split(':'),
          _this$parameters$hour2 = _slicedToArray(_this$parameters$hour, 3),
          _sh = _this$parameters$hour2[0],
          _sm = _this$parameters$hour2[1],
          _this$parameters$hour3 = _this$parameters$hour2[2],
          _ss = _this$parameters$hour3 === void 0 ? '00' : _this$parameters$hour3;
        var _this$parameters$hour4 = this.parameters.hour.end.split(':'),
          _this$parameters$hour5 = _slicedToArray(_this$parameters$hour4, 3),
          _eh = _this$parameters$hour5[0],
          _em = _this$parameters$hour5[1],
          _this$parameters$hour6 = _this$parameters$hour5[2],
          _es = _this$parameters$hour6 === void 0 ? '00' : _this$parameters$hour6;
        var _start = new Date(1970, 0, 1, Number(_sh), Number(_sm), Number(_ss));
        var _end = new Date(1970, 0, 1, Number(_eh), Number(_em), Number(_es));
        var _cursor = new Date(_start.getTime());
        while (_cursor.getTime() <= _end.getTime()) {
          this.createHourOption(_cursor.getHours(), _cursor.getMinutes(), select);
          _cursor.setTime(_cursor.getTime() + stepMillis);
        }
      }
      if (this.parameters.askForChoice) {
        select.value = 'choice';
      }
      return select;
    }
  }, {
    key: "removeOldHourOptions",
    value: function removeOldHourOptions() {
      var select = document.querySelector(this.parameters.element);
      for (var i = select.options.length - 1; i >= 0; i--) {
        select.remove(i);
      }
    }
  }, {
    key: "onValueUpdateSelect",
    value: function onValueUpdateSelect() {
      var select = document.querySelector(this.parameters.element);
      select.addEventListener('change', this.parameters.onValueUpdate);
    }
  }, {
    key: "hourValue",
    get: function get() {
      return this.hourPicker[this.hourPicker.selectedIndex].value;
    },
    set: function set(value) {
      this.hourPicker.value = value;
    }
  }]);
}();
export default HourPicker;